var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "custom-header-checkbox" }, [
    _c("input", {
      directives: [
        {
          name: "model",
          rawName: "v-model",
          value: _vm.isChecked,
          expression: "isChecked",
        },
      ],
      ref: "headerCheckbox",
      attrs: { type: "checkbox" },
      domProps: {
        checked: Array.isArray(_vm.isChecked)
          ? _vm._i(_vm.isChecked, null) > -1
          : _vm.isChecked,
      },
      on: {
        change: [
          function ($event) {
            var $$a = _vm.isChecked,
              $$el = $event.target,
              $$c = $$el.checked ? true : false
            if (Array.isArray($$a)) {
              var $$v = null,
                $$i = _vm._i($$a, $$v)
              if ($$el.checked) {
                $$i < 0 && (_vm.isChecked = $$a.concat([$$v]))
              } else {
                $$i > -1 &&
                  (_vm.isChecked = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
              }
            } else {
              _vm.isChecked = $$c
            }
          },
          _vm.onCheckboxChange,
        ],
      },
    }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }